import { Button, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { User, Users } from 'react-feather';
import styled from '../styled';
import { COLORS } from '../themes/color';
import { DemoButton } from './DemoButton';
import { EarlyAccessDialog } from './EarlyAccessDialog';
import { FeatureIcon } from './FeatureGrid';

const PlanGrid = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  left: -1%;

  @media (max-width: 1100px) {
    margin: ${(p) => p.theme.spacing(2)}px;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const PlanContainer = styled<'div', { selected: boolean }>('div')`
  padding: ${(p) => p.theme.spacing(10)}px ${(p) => p.theme.spacing(2)}px ${(
  p
) => p.theme.spacing(10)}px;

  ${(p) =>
    p.selected &&
    `
    background-color: #fff;
  `}

  @media (min-width: 600px) {
    box-shadow: ${(p) =>
      p.selected ? '0px 2px 15px rgba(0, 0, 0, 0.1)' : 'none'};
    }
  }

  @media (max-width: 600px) {
    &:first-child {
      order: 2;
    }

    &:last-child {
      order: 1;
    }
  }
`;

export const PricingTable = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <PlanGrid>
        <PlanContainer selected={false} style={{ opacity: 0.7 }}>
          <FeatureIcon
            style={{ margin: '0 auto 12px', backgroundColor: COLORS.PAPER }}
          >
            <User size={20} />
          </FeatureIcon>
          <Typography
            variant="h5"
            paragraph
            component="h3"
            color="textSecondary"
            style={{ fontWeight: 900 }}
          >
            Creators
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            Track all your affiliate revenue in one place, with features and
            tools tailored for creator-led businesses.
          </Typography>
          <br />
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => {
              setDialogOpen(true);
            }}
          >
            Request early acccess
          </Button>
          <br />
          <br />
          <br />
          <br />
        </PlanContainer>
        <PlanContainer selected={true}>
          <FeatureIcon
            style={{
              margin: '0 auto 12px',
              backgroundColor: COLORS.PAPER_DARK
            }}
          >
            <Users size={20} />
          </FeatureIcon>
          <Typography
            variant="h5"
            paragraph
            component="h3"
            style={{ fontWeight: 900 }}
          >
            Premium publishers
          </Typography>
          <Typography variant="body2" paragraph>
            Unparalleled commerce content insights, affiliate reporting, and
            advanced tools for media companies &amp; enterprise publishers.
          </Typography>
          <br />
          <DemoButton text="Schedule a demo" variant="contained" />
          <br />
          <br />
          <br />
        </PlanContainer>
        <PlanContainer selected={true}>
          <FeatureIcon
            style={{
              margin: '0 auto 12px',
              backgroundColor: COLORS.PAPER_DARK
            }}
          >
            <Users size={20} />
          </FeatureIcon>
          <Typography
            variant="h5"
            paragraph
            component="h3"
            style={{ fontWeight: 900 }}
          >
            Merchants &amp; Agencies
          </Typography>
          <Typography variant="body2" paragraph>
            Build and maintain your edge in brand, PR, and AI-driven discovery
            with intelligent monitoring and campaign execution tools.
          </Typography>
          <br />
          <DemoButton text="Schedule a demo" variant="contained" />
          <br />
          <br />
          <br />
        </PlanContainer>
      </PlanGrid>
      <EarlyAccessDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      />
    </>
  );
};
